import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';

const { RangePicker } = DatePicker;

const Mt5Withdraw = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [groupEmail, setGroupEmail] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [firstLoad, setFirstLoad] = useState(true);
    const [transactionType, setTransactionType] = useState('TRANSFER_FROM_MT5');
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [statistic, setStatistic] = useState({
        total_adjust: 0,
        total_bonus: 0,
        total_crm_balance: 0,
        total_crm_deposit: 0,
        total_crm_withdraw: 0,
        total_lot_size: 0,
        total_mt5_balance: 0,
        total_mt5_deposit: 0,
        total_mt5_out: 0,
        total_mt5_withdraw: 0,
        total_profit_sharing: 0,
        total_reinvest: 0
    });

    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getTransactionList(event.selected + 1);
    }

    useEffect(() => {
        if (firstLoad) {
            getTransactionList();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            let newData = { ...statistic };
            newData.total_mt5_withdraw = 0;
            setStatistic(newData);
            setPageNumber(1);
            getTransactionList(1);
        }
    }, [props.lang, from, to, productPerpage, email, groupEmail]);

    const handleTimeChange = (e) => {
        if (e) {
            const formattedFromDate = dayjs(e[0]).format("YYYY-MM-DD");
            const formattedToDate = dayjs(e[1]).format("YYYY-MM-DD");
            setFrom(formattedFromDate);
            setTo(formattedToDate);
        } else {
            setFrom("");
            setTo("");
        }
    };

    const getTransactionList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_wallet_overview + `?page=${page}&order_by=DESC&sort_by=date_added`;

        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (email) {
            url += `&email=${email}`
        }
        if (transactionType) {
            url += `&transaction_types=${transactionType}`
        }
        if (groupEmail) {
            url += `&group_email=${groupEmail}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setStatistic(responseJson.data.statistic);
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setPageCount(pageCount);
                    setTotalResultCount(responseJson.data.total_results)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log("error", responseJson.message);
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Date": entry.date_added,
                "Email": entry.email,
                "Name": entry.full_name ? entry.full_name : entry.nick_name,
                "Transaction Type": entry.transaction_type_text,
                "Action": entry.type_text,
                "Amount": Number(entry.amount).toLocaleString('en-US'),
                "Description": entry.remark,
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_wallet_overview + `?page=${pageCount}&order_by=DESC&sort_by=date_added&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }
                if (transactionType) {
                    url += `&transaction_types=${transactionType}`
                }
                if (groupEmail) {
                    url += `&group_email=${groupEmail}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'mt5_withdraw')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });


            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="infoContainer">
                                <div className="px-md-3 py-md-3 px-2 py-4">
                                    <Row className="mx-0 px-0">
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <span className="infoTitle">{translate(props.lang, "TRANSFER_FROM_MT5")}</span>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Personal MT5 Withdraw")}
                                                boxValue={statistic && statistic.total_mt5_deposit && !groupEmail ? Number(statistic.total_mt5_withdraw).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Group MT5 Withdraw")}
                                                boxValue={statistic && statistic.total_mt5_deposit && groupEmail ? Number(statistic.total_mt5_withdraw).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Personal (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Group (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setGroupEmail(e.target.value)}
                                                    value={groupEmail}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="">
                                            <RangePicker
                                                className="w-100 input-transparent input-transparent"
                                                placeholder={[
                                                    translate(props.lang, "From"),
                                                    translate(props.lang, "To"),
                                                ]}
                                                onChange={(e) => handleTimeChange(e)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerpage(e.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()} disabled={loadingExcel}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Action")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Type")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Amount")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Day Count")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Handling Fee")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Receive Amount")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Desc")}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={10}>
                                                    <LoadingV3 theme='dark' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center text-black lh-base`}>{item.date_added ? item.date_added : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.email}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize`}>{item.type_text ? item.type_text.toLowerCase() : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.transaction_type_text ? item.transaction_type_text : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark_arr && JSON.parse(item.remark_arr).length > 1 ? JSON.parse(item.remark_arr)[0] ? JSON.parse(item.remark_arr)[0] : '-' : item.amount ? Number(item.amount).toLocaleString('en-US', digitFormat) + " USD" : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark_arr && JSON.parse(item.remark_arr).length > 1 ? JSON.parse(item.remark_arr)[1] ? JSON.parse(item.remark_arr)[1] : '-' : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark_arr && JSON.parse(item.remark_arr).length > 1 ? JSON.parse(item.remark_arr)[2] ? JSON.parse(item.remark_arr)[2] : '-' : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark_arr && JSON.parse(item.remark_arr).length > 1 ? JSON.parse(item.remark_arr)[3] ? JSON.parse(item.remark_arr)[3] : '-' : item.amount ? Number(item.amount).toLocaleString('en-US', digitFormat) + " USD" : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark ? item.remark : ''}</td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={10}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow text-black"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow text-black"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Mt5Withdraw);